import { IntlProvider } from "react-intl";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { ThemeProvider } from "styled-components";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import AppLocale from "./Utils/AppLocal/Index";
import { defaultTheme, nightMode } from "./Utils/constants";
import AdminRoutes from "./Routes/Allroutes";

function App() {
  const language = useSelector((state) => state.selectLang.language);
  const byDay = useSelector((state) => state?.changeColors?.theme);
  const currentAppLocale = AppLocale[language];

  return (
    <div className="App">
      <ToastContainer />
      <ThemeProvider theme={byDay == "day" ? defaultTheme : nightMode}>
        <IntlProvider
          locale={currentAppLocale}
          defaultLocale="en"
          messages={currentAppLocale?.messages}
        >
          <AdminRoutes />
        </IntlProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
